var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "到期自动提醒设定",
        okText: "确认",
        cancelText: "取消",
        width: "800px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "触发时间",
                        prop: "minDays",
                      },
                    },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "SendMsgDays" },
                        model: {
                          value: _vm.formState.minDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "minDays", $$v)
                          },
                          expression: "formState.minDays",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "发送时间",
                        prop: "sendTimeType",
                      },
                    },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: { "dic-key": "SendMsgTime" },
                        model: {
                          value: _vm.formState.sendTimeType,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "sendTimeType", $$v)
                          },
                          expression: "formState.sendTimeType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "短信内容",
                        prop: "content",
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.formState.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "content", $$v)
                          },
                          expression: "formState.content",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }